import { useEffect } from 'react';

/**
 * Simple Analytics — privacy-first, cookieless analytics.
 * Enabled when VITE_SIMPLE_ANALYTICS=true in .env.
 * https://simpleanalytics.com
 */
export function SimpleAnalytics() {
    const enabled = import.meta.env.VITE_SIMPLE_ANALYTICS === 'true';

    useEffect(() => {
        if (!enabled) return;
        if (document.querySelector('script[data-sa]')) return;

        const script = document.createElement('script');
        script.setAttribute('data-sa', 'true');
        script.setAttribute('data-collect-dnt', 'true');
        script.async = true;
        script.src = 'https://scripts.simpleanalyticscdn.com/latest.js';
        document.body.appendChild(script);
    }, [enabled]);

    return null;
}
